import { TrelloWindow } from '@trello/window-types';
declare const __DEV__: TrelloWindow['__DEV__'];

/**
 * `Object.freeze` has spotty performance. Fortunately, we can derive pretty
 * much all of its perks by simply typing an object with the `Readonly` utility.
 *
 * In dev environments, we can actually freeze our objects, but in other
 * environments the original object is probably more performant.
 */
export const freeze = <T>(obj: T): Readonly<T> =>
  __DEV__ ? Object.freeze(obj) : obj;
